import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getInsightsResources, sortByDate, sortByName } from '../../../../actions/supportActions';

import InsightsTable from './InsightsTable';

class Insights extends Component {
  state = {
    data: [],
    loading: true,
    sortColumnName: 'Uploaded',
    sortDirection: 'desc',
  }

  componentDidMount() {
    this.mounted = true;
    this.getSudyResource();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onSort = sortColumnName => {
    const { sortDirection } = this.state;
    this.setState({ sortColumnName, sortDirection: sortDirection === 'desc' ? 'asc' : 'desc' }, () => {
      this.handleSort(sortColumnName, this.state.sortDirection);
    });
  }

  getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }

  getSudyResource = () => {
    getInsightsResources(this.props.category)
      .then(response => {
        if (this.mounted) {
          if (response) {
            this.setState({ data: response, loading: false });
          } else {
            this.setState({ data: [], loading: false });
          }
        }
      });
  }

  handleSort = (sortColumnName, sortDirection) => {
    const data = [...this.state.data];
    if (sortColumnName === 'Uploaded') {
      data[0] = sortByDate(data[0], sortDirection);
    } else if (sortColumnName === 'Name') {
      data[0] = sortByName(data[0], sortDirection);
    }
    this.setState({ data });
  };


  checkForScroll = () => {
    setTimeout(() => {
      const hasScroll = $('.custom-mri-table--body').get(0).scrollHeight > $('.custom-mri-table--body').height();
      if (hasScroll) {
        const scrollWidth = this.getScrollbarWidth();
        $('.custom-mri-table').addClass('has-scroll');
        $('.custom-mri-table .custom-mri-table--head').attr('style', `padding-right: ${scrollWidth}px`);
      } else {
        $('.custom-mri-table').removeClass('has-scroll');
        $('.custom-mri-table .custom-mri-table--head').removeAttr('style');
      }
    }, 500);
  }

  renderResources = () => {
    const { data, sortColumnName, sortDirection } = this.state;
    const renderTable = (
      <InsightsTable
        onSort={this.onSort}
        sortColumnName={sortColumnName}
        sortDirection={sortDirection}
        data={data[0]}
        checkForScroll={this.checkForScroll}
      />
    );

    return (
      <div className="custom-tab">
        <div className="custom-tab--body custom-tab-block" style={{ paddingTop: 0 }}>
          <div className="support-user-guide-table">
            {renderTable}
          </div>
        </div>
      </div>
    );
  }


  render() {
    const { data, loading } = this.state;

    let renderContent = '';

    if (_.isEmpty(data) && loading) {
      renderContent = (
        <div className="resources-main-container" style={{ paddingLeft: 0 }}>
          <div className="custom-tab">
            loading....
          </div>
        </div>
      );
    }


    if (_.isEmpty(data) && !loading) {
      renderContent = (
        <div className="resources-main-container">
          <div className="custom-tab">
            No records found.
          </div>
        </div>
      );
    }

    if (data.length > 0 && !loading) {
      renderContent = this.renderResources();
    }

    return (
      <div className="resources-main-container study-resources">
        <div className="resources-study-selector">
          <h4 className="support-page-title">Insights Notifications</h4>
        </div>
        <div className="study-resources-main">
          {renderContent}
        </div>
      </div>
    );
  }
}


Insights.propTypes = {
  category: PropTypes.instanceOf(Object),
};

export default Insights;
